import { render, staticRenderFns } from "./YourStore.vue?vue&type=template&id=9684bf38&scoped=true&"
import script from "./YourStore.vue?vue&type=script&lang=ts&"
export * from "./YourStore.vue?vue&type=script&lang=ts&"
import style0 from "./YourStore.vue?vue&type=style&index=0&id=9684bf38&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9684bf38",
  null
  
)

export default component.exports